import { autoinject, bindable } from 'aurelia-framework';
import { NodeModel } from "../../models/node-model";

/** UI component for showing service structure tree */
@autoinject
export class ServiceStructure {
	@bindable searchTerm: string;

	@bindable nodes: NodeModel[];
	@bindable selectedNode: NodeModel;
}
